/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMinusVertical = createReactComponent("minus-vertical", "IconMinusVertical", [
  ["path", { d: "M12 5v14", key: "svg-0" }]
]);

export { IconMinusVertical as default };
//# sourceMappingURL=IconMinusVertical.js.map
